import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Manager, Reference, Popper } from 'react-popper'

import classNames from 'classnames'
import Fade from 'components/misc/Fade'
import Popover from 'components/report/onboarding/Popover'
import styles from './styles/Onboarding.css'
import tooltipStyles from 'components/misc/styles/Tooltip.css'

export const Tooltip = ({
  children,
  header,
  content,
  closeOnboarding,
  placement = 'top',
  refClassName = ''
}) => {
  const [show, setShow] = useState(false)
  const user = useSelector(({ ui }) => ui.user)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const { localStorage } = window
    const onboarded = localStorage.getItem('signup-onboarded')
    if (onboarded || !user) {
      return
    }
    setShow(true)
  })

  const handleClose = () => {
    const { localStorage } = window
    const onboarded = localStorage.getItem('signup-onboarded')
    if (onboarded || !user) {
      return
    }
    localStorage.setItem('signup-onboarded', 'true')
    setShow(false)
  }

  return (
    <Manager>
      <Fade className={styles.fade} show={show && !closeOnboarding}>
        <Popper
          placement={placement}
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [45, 12]
              }
            },
            {
              name: 'flip',
              options: {
                fallbackPlacements: []
              }
            }
          ]}
        >
          {({ ref, style, placement, arrowProps }) => (
            <div
              className={classNames(tooltipStyles.popperBase, styles.tooltip)}
              ref={ref}
              style={style}
              data-placement={placement}
            >
              <Popover
                header={header}
                content={content}
                nextOnboarding={handleClose}
                skipOnboarding={handleClose}
              />
              <div className={classNames(tooltipStyles.arrow, tooltipStyles.arrowWhite)} ref={arrowProps.ref} style={arrowProps.style} />
            </div>
          )}
        </Popper>
      </Fade>
      <Reference>
        {({ ref }) => (
          <div className={refClassName} ref={ref}>
            {children}
          </div>
        )}
      </Reference>
    </Manager>
  )
}

export default Tooltip
